<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-action">
      <div class="button button-close">
        <button class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </button>
      </div>
    </div>
    <div class="popup-container">
      <div class="popup">
        <div class="popup-title">
          <span class="popup-title-main">タグづけされた{{state.visibleTargetTypeName}}</span>
          <span class="popup-title-sub">「{{state.visibleTargetName}}」がタグ付けされている{{state.visibleTargetTypeName}}の一覧。</span>
        </div>
        <div class="popup-content">
          <ul class="popup-content-list">
            <li v-for="(list, dateIndex) in data.lists" :key="'date_list' + dateIndex" class="popup-content-list-item">
              {{list.title}}
            </li>
            <li v-if="data.complete &&data.lists.length <= 0" class="popup-content-list-item">設定された{{state.visibleTargetTypeName}}はありません</li>
          </ul>
          <div v-if="!data.complete" ref="LoadingBlock">
            <FontawesomeIcon :icon="['fal','spinner-third']" size="2x" class="mt20 mb20 icn fa-spin" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'

export default defineComponent({
  setup (props, context) {
    const store = context.root.$store
    const { tag } = store.state

    const state = reactive({
      visibleTargetTypeName: computed(() => tag.currentTypeName),
      visibleTargetName: computed(() => tag.currentName)
    })

    const data = reactive({
      lists: computed(() => tag.sharedList),
      // 全読み込み済みフラグ
      complete: computed(() => tag.sharedComplete)
    })

    const close = () => {
      context.emit('closeTagSharedList')
    }

    return {
      state,
      data,
      close
    }
  }
})
</script>

<style lang="scss" scoped>
.popup {
  &-content {
    &-list {
      max-height: 400px;
      overflow-y: auto;
      &-item {
        border-bottom: 1px solid $color-line;
        padding: 20px;
        font-size: 1.4rem;
        color: $color-content;
      }
    }
  }
  &-action {
    width: auto;
    left: auto;
    right: 0;
    border-top-left-radius: 8px;
    .btn {
      height: 78px;
    }
  }
}
</style>
